<template>
<div @keydown.esc="close()" @keydown.enter="save()">
    
    <div class="field" v-if="field_type == 'text'">
        <label>{{label}}</label>
        <input type="text" :value="value" ref="field" @change="onChange()" :placeholder="placeholder">						
    </div>

    <div class="field" v-if="field_type == 'textarea'">
        <label>{{label}}</label>
        <textarea cols="30" rows="10" :value="value" ref="field" @change="onChange()" :placeholder="placeholder"></textarea>						
    </div>

    <div class="field" v-if="field_type == 'wysiwyg'">
        <label>{{label}}</label>
        <textarea cols="30" rows="10" :value="value" ref="field" @change="onChange()" :placeholder="placeholder"></textarea>						
    </div>

    <div class="field" v-if="field_type == 'number'">
        <label>{{label}}</label>
        <input type="number" :step="generic_field_editor.step" :min="generic_field_editor.min" :max="generic_field_editor.max" :value="value" ref="field" @change="onChange()" :placeholder="placeholder">
    </div>

    <p v-if="0">
        field types - do them when needed:
        - select, with options        
        - select/remove media item
    </p>

    <div class="grid">
        <div class="col m50">
            <div class="btn btn-white shadowed btn-full" @click="close()">Cancel</div>
        </div>
        <div class="col m50">
            <div class="btn btn-black btn-full" @click="save()" _v-if="generic_field_editor.onSave">Save</div>
        </div>
    </div>

</div>
</template>
<script>
import mixins from '.././mixins.js'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		
	},

	data(){ return {                            
        
	}},

	computed: {

        generic_field_editor(){ return this.$store.state.generic_field_editor },

        field_type(){ return this.generic_field_editor.field_type },
        value(){ return this.generic_field_editor.value },
        label(){ return this.generic_field_editor.label },
        placeholder(){ return this.generic_field_editor.placeholder },

	},

	methods: {

        onChange(){

        },

        close(){
            this.set_generic_field_editor({ active:false, })
        },

        getValue(){
            var value = this.$refs.field.value
            // perhaps if wysiwyg, select or something, getting value is slightly different
            return value
        },

        save(){
            if( this.generic_field_editor.onSave ) this.generic_field_editor.onSave( this.getValue() )
        },        

	},

	created(){
       

    },
    
    mounted(){

        this.$refs.field.focus()

    },

}
</script>



// WEBPACK FOOTER //
// src/views/GenericFieldEditor.vue